import { Update } from '@ngrx/entity';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { IPortfolioMarketData } from '@easy-lib/modules/portfolio';
import {
	CashSettlement,
	CashSettlementRequest,
	PhysicalSettlement,
	PhysicalSettlementRequest,
	Position,
	SettlementType
} from '../../modules/option/models/option.model';

export const PositionAction = createActionGroup({
	source: 'position',
	events: {
		load: emptyProps(),
		loadedError: emptyProps(),
		empty: emptyProps(),
		requestDone: emptyProps(),
		set: props<{ values: Position[] }>(),
		add: props<{ value: Position }>(),
		update: props<Update<Position>>(),
		upsert: props<{ value: Position }>(),
		loadCashSettlement: props<{ id: string }>(),
		loadPhysicalSettlement: props<{ id: string }>(),
		updateCashSettlement: props<{ value: CashSettlement }>(),
		updatePhysicalSettlement: props<{ value: PhysicalSettlement }>(),
		createCashSettlement: props<{ value: CashSettlementRequest }>(),
		createPhysicalSettlement: props<{ value: PhysicalSettlementRequest }>(),
		deleteSettlementRequest: props<{ id: string; positionId: string; settlementType: SettlementType }>(),
		deleteCashSettlement: props<{ positionId: string }>(),
		deletePhysicalSettlement: props<{ positionId: string }>(),

		unSubscribeMarketToLs: emptyProps(),
		subscribeMarketToLs: emptyProps(),
		setMarketData: props<{ values: Partial<IPortfolioMarketData>[] }>(),
		upsertMarketData: props<{ value: Partial<IPortfolioMarketData> }>()
	}
});
